import {
  FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES,
  STAFF_AND_FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES,
  STAFF_NO_AVAILABLE_SLOTS_ERROR_CODES,
} from "libs/helpers/src/constants/ManuallyHandledErrorCodes";

export type ReasonType = ReturnType<typeof getReasonFromErrorCode>;

export const getReasonFromErrorCode = (errorCode: string) => {
  if (STAFF_AND_FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES.includes(errorCode)) {
    return "both";
  }
  if (STAFF_NO_AVAILABLE_SLOTS_ERROR_CODES.includes(errorCode)) {
    return "staff";
  }
  if (FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES.includes(errorCode)) {
    return "facility";
  }

  return undefined;
};
